import React, { Fragment } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import News from "./pages/News";
import SiteLayout from "./components/ui/SiteLayout";
import "./App.css"; // Để thêm CSS cơ bản
import { Helmet } from "react-helmet-async";
import { useTranslation } from "./context/LanguageContext";
import Contact from "./pages/Contact";

function App() {
  const { translate } = useTranslation();
  return (
    <Fragment>
      <Helmet>
        <title>{translate("meta.title")}</title>
        <meta name="description" content={translate("meta.description")} />
        {/* <meta name="viewport" content="width=1920" /> */}
      </Helmet>
      <Router>
        <Routes>
          {/* Site layout routes */}
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          {/* No bare PDF routes anymore */}
        </Routes>
      </Router>
    </Fragment>
  );
}

export default App;
